let sizeTabs = document.querySelectorAll('.size-tab');
sizeTabs.forEach(el => {
    el.addEventListener("click", function () {
        sizeTabs.forEach(tab => tab.classList.remove('active-tab'));
        el.classList.add('active-tab');
    });
});

let sizeSelect = document.querySelector('.size-table__col select');
let dynamicSizes = document.querySelectorAll('.selection-size div');
if (sizeSelect) {
    sizeSelect.addEventListener('change', () => {
        dynamicSizes.forEach(el => el.classList.add('hidden-size'));
        dynamicSizes.forEach(el => {
            if (el.classList.contains(sizeSelect.value + '-size')) {
                el.classList.remove('hidden-size');
            }
        });
    });
}

let measInfo = document.querySelector('.measurements-info');
let measurementsData = document.getElementById('measurements-data');
let dimSelect = document.querySelector('.measurements-dimensions');

if (measurementsData) {
    const measData = JSON.parse(measurementsData.textContent);
    const measOpt = document.querySelector('.measurements-options');
    fillOptions(measData, measOpt);
    let selectedSize = measOpt.value;
    measInfo.querySelector('.measurements-type').innerHTML = '<span>Chest</span><span>Length</span>';

    if (selectedSize) {
        const chestKey = `${selectedSize}_chest`;
        const lengthKey = `${selectedSize}_length`;
        const selectedData = measData[0];
        measInfo.querySelector('.measurements-in').innerHTML = `<span>${selectedData[chestKey]} in</span><span>${selectedData[lengthKey]} in</span>`;
        measInfo.querySelector('.measurements-cm').innerHTML = `<span>${(+selectedData[chestKey] * 2.54).toFixed(2)} cm</span><span>${(+selectedData[lengthKey] * 2.54).toFixed(2)} cm</span>`;
        hideOnMob();
    }

    measOpt.addEventListener('change', () => {
        const selectedSize = measOpt.value;
        measInfo.querySelector('.measurements-type').innerHTML = '<span>Chest</span><span>Length</span>';
        if (selectedSize) {
            const chestKey = `${selectedSize}_chest`;
            const lengthKey = `${selectedSize}_length`;
            const selectedData = measData[0];
            measInfo.querySelector('.measurements-in').innerHTML = `<span>${selectedData[chestKey]} in</span><span>${selectedData[lengthKey]} in</span>`;
            measInfo.querySelector('.measurements-cm').innerHTML = `<span>${(+selectedData[chestKey] * 2.54).toFixed(2)} cm</span><span>${(+selectedData[lengthKey] * 2.54).toFixed(2)} cm</span>`;
            hideOnMob();
        }
    });
}

function fillOptions(measData, measOpt) {
    if (measData[0].xxs_chest) measOpt.innerHTML += '<option value="xxs">Size XXS</option>';
    if (measData[0].xs_chest) measOpt.innerHTML += '<option value="xs">Size XS</option>';
    if (measData[0].s_chest) measOpt.innerHTML += '<option value="s">Size S</option>';
    if (measData[0].m_chest) measOpt.innerHTML += '<option value="m">Size M</option>';
    if (measData[0].l_chest) measOpt.innerHTML += '<option value="l">Size L</option>';
    if (measData[0].xl_chest) measOpt.innerHTML += '<option value="xl">Size XL</option>';
    if (measData[0].xxl_chest) measOpt.innerHTML += '<option value="xxl">Size XXL</option>';
    if (measData[0].xxxl_chest) measOpt.innerHTML += '<option value="xxxl">Size XXXL</option>';
    if (measData[0].xxxxl_chest) measOpt.innerHTML += '<option value="xxxxl">Size 4XL</option>';
    if (measData[0].xxxxxl_chest) measOpt.innerHTML += '<option value="xxxxxl">Size 5XL</option>';
    if (measData[0].xxxxxxl_chest) measOpt.innerHTML += '<option value="xxxxxxl">Size 6XL</option>';

    measOpt.querySelectorAll('option').forEach(el => {
        if (el.innerText.trim() === '') el.remove();
    });
}

if (dimSelect) dimSelect.addEventListener('change', hideOnMob);

function hideOnMob() {
    if (window.innerWidth < 768) {
        let dimSelect = document.querySelector('.measurements-dimensions');
        if (dimSelect.value === 'cm') {
            document.querySelector('.measurements-cm').style.display = 'flex';
            document.querySelector('.measurements-in').style.display = 'none';
        } else {
            document.querySelector('.measurements-cm').style.display = 'none';
            document.querySelector('.measurements-in').style.display = 'flex';
        }
    }
}

document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const sizeButton = event.target.closest('.product__button-size-guide');
    if (sizeButton) {
        const sizePopup = document.querySelector('.sizeguide');
        if (!sizePopup) return;
        event.preventDefault();
        sizePopup.style.display = 'flex';
        return;
    }

    const sizeClose = event.target.closest('.size-popup__wrapper .icon-close');
    if (sizeClose) {
        const sizePopup = sizeClose.closest('.sizeguide');
        if (sizePopup) sizePopup.style.display = 'none';
    }
});
